import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import Vuelidate from 'vuelidate'
// import { VueReCaptcha } from 'vue-recaptcha-v3'

import App from './App'
import Home from './pages/Home'
import Terms from './pages/Terms'
import Privacy from './pages/Privacy'
import NotFound from './pages/NotFound'

import VueScrollTo from 'vue-scrollto'

// TailwindCSS
import "@/assets/styles/tailwind.css";

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(VueScrollTo)
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})
Vue.use(Vuelidate)

const router = new VueRouter({
  mode: "history",
  routes: [
    { path: '/', component: Home },
    { path: '/terms', component: Terms },
    { path: '/privacy', component: Privacy },
    { path: '*', component: NotFound }
  ]
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next()
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
